module.exports = __webpack_public_path__ + "static/img/Memory.29e7d4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/start/assets/Memory.jpg
// module id = oTOq
// module chunks = 0